(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('pohTops', {
        templateUrl: 'views/components/views/pohTops/pohTops.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'stateService', 'translateService', 'modalService', 'ieScreenBlockService', 'pohTopsService', 'posComponentService', 'rememberService', function ($stateParams, utilityService, stateService, translateService, modalService, ieScreenBlockService, pohTopsService, posComponentService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;

            let translations = {
                confirm_title: '',
                check_orders_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            let variableNames = {
                date_fom: '',
                date_tom: '',
                dateselector_index: ''
            };

            let progressInfo = {
                runProgress: 'START',
                label: 'progressbar',
                field: '',
                max: 0,
                min: 0,
                step: 0,
                finishclose: '1',
                abortclose: false
            };

    		vm.model = {
                bgPohTops: {
                    selected: 'SHOW',
                    buttons: [
                        { id: 'SHOW', label: 'bg_pohtops_show', color: 'primary', onClick: () => vm.model.bgPohTops.selected = 'SHOW' },
                        { id: 'SELECT', label: 'bg_pohtops_select', color: 'primary', onClick: () => vm.model.bgPohTops.selected = 'SELECT' }
                    ]
                },
                poStatusesButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('postatus_no') }
                ],
                poStatusesNewButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.postatus_no_new = 'NoChange' }
                ],
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filterval = '' }
                ],
    			setting: {},
    			selectListPoStatuses: [],
    			selectListPoStatusesNew: [],
    			itemsListPohTops: [],
                showChecked: false,
                checkingOrders: false,
                lockedNewStatus: false
    		};

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

    		// #region LOAD PROCEDURE CALLS

            async function loadSetting() {
                vm.model.setting = (await pohTopsService.getSetting({
                    argtype: argType,
                    argvalue: argValue
                }))[0];

                return Promise.all([
                    loadPohTops()
                ]);
            }
            
            async function loadPoStatuses() {
                vm.model.selectListPoStatuses = await posComponentService.listPoStatuses({ add_all: '1' });
            }

            async function loadPoStatusesNew() {
                vm.model.selectListPoStatusesNew = await posComponentService.listPoStatuses({ add_all: 'nochange' });
            }

            async function loadPohTops() {
                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.postatus_no, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.filterval, true) !== true) return;

    			ieScreenBlockService.start();
    			
    			vm.model.itemsListPohTops = [];
                
                return pohTopsService.listPohTops(vm.model.setting).then((list) => {
                    vm.model.itemsListPohTops = list;
                    
    				for (var i = 0; i < vm.model.itemsListPohTops.length; i++) {
    					if (angular.isDefined(vm.model.itemsListPohTops[i].item_is_selected) && vm.model.itemsListPohTops[i].item_is_selected === '0') {
    						vm.model.showChecked = false;
    					}
    				}
                    
    				ieScreenBlockService.stop();
    			});
    		}

            function processNewStatus() {
    			if (utilityService.validateParmsValue(vm.model.setting.postatus_no_new) !== true) return;
    
                pohTopsService.setNewStatus({ postatus_no_new: vm.model.setting.postatus_no_new }).then((response) => {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedNewStatus = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedNewStatus = false;
    					loadPohTops();
                    }
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'date_fom':
                    case 'date_tom':
                    case 'dateselector_index':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            function rememberSelectedItems() {
                let variableNameSelectedItems = 'w_pohtops.selected_items';
                let selectedItems = '';

                if (vm.model.itemsListPohTops) {
                    for (let i = 0; i < vm.model.itemsListPohTops.length; i++) {
                        if (vm.model.itemsListPohTops[i].item_is_selected && vm.model.itemsListPohTops[i].item_is_selected === '1') {
                            if (selectedItems.length > 1) {
                                selectedItems += ',';
                            }

                            selectedItems += vm.model.itemsListPohTops[i].item_id;
                        }
                    }
                }

                if (utilityService.validateParmsValue(variableNameSelectedItems) !== true) return;
                if (utilityService.validateParmsValue(selectedItems, true) !== true) return;

                rememberService.remember(variableNameSelectedItems, selectedItems).then(() => processNewStatus());
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'postatus_no':
                        vm.model.setting.postatus_no = 'ALL';

                        if (vm.model.setting.postatus_no === 'ALL') loadPohTops();
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region CHECK ORDER FUNCTIONS

            function progressCheckOrders(items) {
    			let increment = 1, skip = 0, failed = 0, step = 0;
    			progressInfo.step = 0;
                
                function doStep() {
                    setTimeout(() => {
                        modalService.progressInfo.finishclose = '0';

                        if (progressInfo.runProgress === 'ABORT') return;
                        if (items[step] === undefined) return;
                        
    					if (items[step].item_id === '-1' || items[step].item_id === '0') {
    						skip++;
    						step = progressInfo.step + skip + failed;
    						doStep();
                        } else if (utilityService.validateParmsValue(vm.model.setting.filterval) === true && items[step].item_filtervalue && items[step].item_filtervalue.toLowerCase().indexOf(vm.model.setting.filterval.toLowerCase()) === -1) {
    						skip++;
    						step = progressInfo.step + skip + failed;
    						doStep();
    					} else {
                            step = progressInfo.step + skip + failed;

                            if (items[step] === undefined) return;

    						progressInfo.field = items[step].item_id + ': ' + items[step].item_name;
    						modalService.progressInfo.field = progressInfo.field;
                            
                            pohTopsService.checkOrder({ poh_keyno_top: items[step].item_id }).then(function (response) {
                                vm.model.itemsListPohTops.forEach((poh) => {
                                    if (poh.item_id === items[step].item_id) {
                                        poh.item_glyphicon = response[0].item_glyphicon;
                                        poh.item_glyphicon_color = response[0].item_glyphicon_color;
                                    }
                                });

                                progressInfo.step += increment;
                                modalService.progressInfo.step = progressInfo.step;
                                modalService.progressInfo.finishclose = '1';

                                doStep();
                            });
    					}
    				});
                }

    			doStep();
    		}

    		vm.checkOrders = function () {
                vm.model.checkingOrders = true;

                progressInfo.runProgress = 'START';
    			progressInfo.label = 'progressbar';
    			progressInfo.field = '';
    			progressInfo.max = 0;
    			progressInfo.step = 0;
                
    			let filteredList = [];

                if (vm.model.itemsListPohTops.length === 0) {
                    modalService.confirm({
                        type: 'warning',
                        title: translations.confirm_title,
                        message: translations.check_orders_message,
                        okLabel: translations.confirm_ok_label,
                        cancelLabel: translations.confirm_cancel_label
                    }).then(() => {
                        vm.model.checkingOrders = false;
                    }, () => {
                        vm.model.checkingOrders = false;
                    });
                } else {
                    if (utilityService.validateParmsValue(vm.model.setting.filterval) === true) {
                        vm.model.itemsListPohTops.forEach((item) => {
                            if (item.item_id !== '-1' && item.item_id !== '0' && item.item_filtervalue && item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.filterval.toLowerCase()) !== -1) {
                                progressInfo.max++;
                                filteredList.push(item);
                            }
                        });

                        progressInfo.max = filteredList.length;
                        progressCheckOrders(filteredList);
                    } else {
                        vm.model.itemsListPohTops.forEach((item) => {
                            if (item.item_id !== '-1' && item.item_id !== '0') {
                                progressInfo.max++;
                            }
                        });

                        progressInfo.max = vm.model.itemsListPohTops.length;
                        progressCheckOrders(vm.model.itemsListPohTops);
                    }

                    modalService.showProgress(progressInfo).then((value) => {
                        progressInfo.runProgress = value;

                        if (progressInfo.runProgress === 'ABORT') {
                            vm.model.checkingOrders = false;
                        }

                        if (progressInfo.runProgress === 'FINISH') {
                            vm.model.checkingOrders = false;
                        }
                    });
                }
    		};

            // #endregion CHECK ORDER FUNCTIONS

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgPohTops = function (value) {
                vm.model.bgPohTops.selected = value;
            };

            // #endregion BUTTON GROUP SINGLE FUNCTION

    		// #region TOGGLE FUNCTIONS
            
    		vm.toggleChosen = function (item) {
                if (utilityService.validateParmsValue(item.item_id) !== true) return;
    			
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };
            
            vm.selectAll = function () {
                vm.model.itemsListPohTops.forEach((item) => {
    				if (utilityService.validateParmsValue(item.item_filtervalue, true) !== true) return;
    				if (item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.filterval.toLowerCase()) === '-1') return;
    				if (utilityService.validateParmsValue(item.item_id) !== true) return;
    
                    item.item_is_selected = '1';
                    vm.model.showChecked = true;
    			});
    		};
            
    		vm.unselectAll = function () {
                vm.model.itemsListPohTops.forEach((item) => {
    				if (utilityService.validateParmsValue(item.item_filtervalue, true) !== true) return;
    				if (item.item_filtervalue.toLowerCase().indexOf(vm.model.setting.filterval.toLowerCase()) === '-1') return;
    				if (utilityService.validateParmsValue(item.item_id) !== true) return;
    
                    item.item_is_selected = '0';
                    vm.model.showChecked = false;
    			});
    		};

            // #endregion TOGGLE FUNCTIONS

            // #region UPDATE NEW STATUS BUTTON FUNCTION
    
            vm.updateNewStatus = function () {
                vm.model.lockedNewStatus = true;
    			rememberSelectedItems();
            };

            // #endregion UPDATE NEW STATUS BUTTON FUNCTION

            // #region FIELD DATE RANGE CHANGE FUNCTION

            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
                vm.model.setting.date_fom = startDate;
                vm.model.setting.date_tom = endDate;
                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

                if (vm.model.setting.date_fom) rememberFunc('date_fom');
                if (vm.model.setting.date_tom) rememberFunc('date_tom');
                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
                    //vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;
                    loadPohTops();
                }
            }

            // #endregion FIELD DATE RANGE CHANGE FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'postatus_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.postatus_no) !== true) return;

                        vm.model.setting.postatus_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.postatus_no) !== true) return;

                        loadPohTops();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                loadPoStatuses();
                loadPoStatusesNew();
            };

            // #endregion ON INIT FUNCTION

    	}]
    });
})();
